import { html } from "lit-html";

export const renderLoadingBounceElement = () => {
  return html`
    <div class="wec-e-loading-bounce">
      <div class="wec-e-loading-bounce__loading-bounce"></div>
      <div class="wec-e-loading-bounce__loading-bounce"></div>
    </div>
  `;
};
